export default "__VITE_ASSET__Dj98_uCC__"